'use client';

import type { FormModule } from '@commenda/types';
import type React from 'react';

export const ModuleRenderer = ({
  module,
  componentRegistry,
  hideName = false,
}: {
  module: FormModule;
  componentRegistry: Record<string, React.FC<any>>;
  /** Set when the module name is already shown as the sheet title. */
  hideName?: boolean;
}) => {
  if (!module?.components?.length) {
    return (
      <div className="text-center py-8">
        <p className="txt-small-regular text-text-tertiary">
          This module has no components configured.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full bg-bg-primary border border-border-secondary rounded-lg">
      <div className="flex flex-col gap-xl p-6">
        {module.name && !hideName && (
          <h3 className="txt-medium-medium text-text-primary">{module.name}</h3>
        )}
        {module.description && (
          <p className="txt-xs-regular text-text-tertiary">
            {module.description}
          </p>
        )}
        <div className="flex flex-col gap-xl">
          {module.components
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            .map((component, index) => {
              const Component = componentRegistry[component.component];
              if (!Component) {
                return null;
              }
              return (
                <Component
                  key={
                    component.id ??
                    component.fieldId ??
                    `${component.component}-${index}`
                  }
                  {...component}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};
